<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-12-23 14:26:40
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-23 14:50:10
 * @FilePath: \合联\oms\src\view\system\otsCityMapping\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/system/otsCityMapping.js";
import { getCity } from "@/api/system/city";
export default {
  name: "otsCityMapping",
  components: {
    cTable
  },
  mounted() {
    getCity({ page: 1, pageSize: 9999, country_id: 29 }).then(res => {
      this.modals.add.fields.forEach(t => {
        if (t.key === "zajil_city_name") t.options = res.data.payload.rows;
      });
    });
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              zajil_city_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              village_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              agent_city: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              city_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              region_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            { zajil_city_name: 24 },
            { village_id: 24 },
            { agent_city: 24 },
            { city_id: 24 },
            { region_id: 24 }
          ],
          fields: [
            {
              name: this.$tz("合联,城市"),
              key: "zajil_city_name",
              component: "Select",
              placeholder: () => this.$tz("合联,城市"),
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              default: ""
            },
            {
              name: this.$tz("Village ID"),
              key: "village_id",
              component: "InputNumber",
              default: "",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            },
            {
              name: () => this.$tz("代理,城市,名称"),
              key: "agent_city",
              component: "Input",
              placeholder: () => this.$tz("代理,城市,名称")
            },
            {
              name: this.$tz("代理,城市,ID"),
              key: "city_id",
              component: "InputNumber",
              default: "",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            },
            {
              name: this.$tz("Region ID"),
              key: "region_id",
              component: "InputNumber",
              default: "",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary"
              },
              id: 1963
            }
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$tz("新增"));
              });
            }
          }
        }
      },
      fields: [
        // {
        //   name: () => this.$tz("合联,城市,ID"),
        //   key: "vnlin_city_id",
        //   minWidth: 130
        // },
        {
          name: () => this.$tz("合联,城市,名称"),
          key: "vnlin_city",
          minWidth: 130
        },
        {
          name: () => this.$tz("Village ID"),
          key: "village_id",
          minWidth: 130
        },
        {
          name: () => this.$tz("代理,城市,名称"),
          key: "agent_city",
          minWidth: 130
        },
        {
          name: () => this.$tz("代理,城市,ID"),
          key: "city_id",
          minWidth: 130
        },
        {
          name: () => this.$tz("Region ID"),
          key: "region_id",
          minWidth: 130
        },
        {
          name: () => this.$tz("更新时间"),
          key: "update_time",
          minWidth: 130
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "edit",
              fnName: "edit",
              bind: {
                type: "primary"
              },
              id: 1962
            },
            {
              name: () => this.$tz("删除"),
              type: "del",
              fnName: "del",
              bind: {
                type: "error"
              },
              id: 1961
            }
          ],
          methods: {
            edit({ row }) {
              this.handleRequestMethods(
                "detail",
                { id: row.id },
                false,
                true
              ).then(res => {
                this.getModal("add").open(res.payload, function() {
                  this.setTitle(this.$tz("编辑"));
                });
              });
            },
            error({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
